@if (!this.loading && !camara) {
  <app-breadcrumb
    listado="/main/camaras"
    etiquetaListado="Cámaras"
    [titulo]="camara?.identificacion"
  ></app-breadcrumb>
  <app-empty-state
    icon="videocam_off"
    message="No se encontró la cámara"
  ></app-empty-state>
} @else if (!this.loading && camara) {
  <app-breadcrumb
    listado="/main/camaras"
    etiquetaListado="Cámaras"
    [titulo]="camara?.identificacion"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas de la pestaña Info -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>videocam</mat-icon></div>
    <div class="encabezado-texto">
      <h1>{{ camara.identificacion }}</h1>
      @if (subtitulo) {
        <span class="encabezado-nombre">{{ subtitulo }}</span>
      }
      <div class="encabezado-chips">
        @if (camara.tipo) {
          <span class="chip">
            <mat-icon>category</mat-icon>
            {{ camara.tipo }}
          </span>
        }
        @if (camara.cliente?.nombre) {
          <span class="chip">
            <mat-icon>business</mat-icon>
            {{ camara.cliente.nombre }}
          </span>
        }
      </div>
    </div>
    <!-- Mismo permiso que pide el listado para editar -->
    @if (puedeEditar) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar cámara"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalles-camara-info [camara]="camara"></app-detalles-camara-info>
      </ng-template>
    </mat-tab>

    <!-- Video en vivo y grabaciones: con el permiso que pide el listado -->
    @if (puedeVerStream) {
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">videocam</mat-icon>
          <span>Video</span>
        </ng-template>
        <ng-template matTabContent>
          <!-- Sin alto impuesto: el host de camaras-multiple tiene overflow
               hidden y cualquier altura recorta el mosaico y los controles. -->
          <app-camaras-multiple
            style="display: block; width: 100%"
            [data]="[camara._id]"
          ></app-camaras-multiple>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
} @else {
  <app-detalle-esqueleto
    icono="videocam"
    listado="/main/camaras"
    etiquetaListado="Cámaras"
    [pestanas]="2"
  ></app-detalle-esqueleto>
}
